<template>
  <!-- 중첩 라우터를 위한 컨텐츠 컴포넌트 -->
  <router-view :locale="locale" :isIdle="isIdle"></router-view>
</template>

<script>
export default {
  name: 'Content',
  props: [
    'locale',
    'isIdle'
  ]
}
</script>
